
import { __ } from 'bits/intl'
import { currentPath } from 'bits/location'
import { Component, Vue } from 'bits/vue'
import DropdownMobile from 'library/v4/components/dropdown-mobile.vue'
import BaseIcon from 'vuecomponents/base_icon.vue'

@Component({
  components: {
    BaseIcon,
    DropdownMobile,
  },
})
export default class MembershipFooter extends Vue {
  moreServices = [
    {
      title: __('Sign up'),
      link: '/auth/signup',
    },
    {
      title: __('About'),
      link: '/about/us',
    },
    {
      title: __('Jobs'),
      link: 'https://padlet.jobs',
    },
    {
      title: __('Support'),
      link: 'https://padlet.help',
    },
    {
      title: __('Accessibility statement'),
      link: '/about/accessibility',
    },
    {
      title: __('Privacy policy'),
      link: '/about/privacy',
    },
    {
      title: __('Terms of service'),
      link: '/about/terms',
    },
    {
      title: __('Content policy'),
      link: '/about/content',
    },
  ]

  mounted() {
    if (currentPath().endsWith('/memberships') || currentPath().includes('/membership')) {
      document.getElementById('membership')?.classList.add('active')
    } else if (currentPath().includes('/features')) {
      document.getElementById('product')?.classList.add('active')
    } else {
      document.getElementById('home')?.classList.add('active')
    }
  }
}
